module.exports = __webpack_public_path__ + "static/memory_img1M@2x-121e1a875e0683375aa642a5ee8141e5.png";